import { createIcon } from './createIcon'

export const ArrowUpIcon = createIcon({
  displayName: 'ArrowUpIcon',
  viewBox: '0 0 14 14',
  path: [
    <path
      d="M7 4.33333L9.66667 7M7 4.33333L7 9.66667M7 4.33333L4.33333 7M0.999999 7C0.999999 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 0.999999C3.68629 0.999999 0.999999 3.68629 0.999999 7Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />,
  ],
})
